export default __webpack_public_path__ + "static/media/10.curso.ae6516c5.png";